import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { selectprocessedData } from "../../../features/importSlice";
import { signInUser } from "../../Utility/Auth";

// const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api";

const SelectCategoryImportSubCategory = ({
  categories,
  categoryName,
  code
  // handleSelect,
  // mcId,
}) => {
  const dispatch = useDispatch();
  const [selectedOption, setSelectedOption] = useState(null);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [matched, setMatched] = useState(true);
  const data = useSelector(state=>state.importReducer)

  // console.log('categories',code, categoryName)

  useEffect(() => {
    // const fetchcategorys = async () => {
    try {
      // const result = await axios.get(`${BASE_URL}/category/list/${aamarId}`);
      let options =[]
        categories?.map((element) => {
          options.push({
            label: element.name,
            value: element._id,
            mcId: element.mcId,
          });
    })

      // console.log("options:", options);

      setCategoryOptions(options);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching category:", error);
      setLoading(false);
    }
    // };

    // fetchcategorys();
  }, [categories]);


  useEffect(() => {
    if (categoryName && categories?.length > 0) {
      const cleanName = String(categoryName).trim().toLowerCase();
      const result = categories?.find(
        (item) =>
          item?.name?.trim().toLowerCase() === cleanName ||
          item?._id === categoryName ||
          String(item?.mcId) === cleanName
      );

      if (result) {
        setMatched(true);
        setSelectedOption({
          label: `${result?.name}`,
          value: `${result?._id}`,
          mcId: result?.mcId,
        });
      } else {
        if (!selectedOption?.value) {
          setMatched(false);
          setSelectedOption({
            label: "Select category",
            value: "",
          });
        }
      }
    } else if (!selectedOption?.value) {
      setMatched(false);
      setSelectedOption({
        label: "Select category",
        value: "",
      });
    }
  }, [categoryName, categories]);

  

  // Update Selected Value
  const setcategoryHandler = ({ id, name,mcId }) => {
    const selected = data?.processedData?.find(
      (pro) => pro.code === code
    );
    // console.log("products", selected, name);
    const rest = data?.processedData?.filter(
      (pro) => pro.code !== code
    );

    let products = [
      ...rest,
      {
        ...selected,
        mc: id,
        category: name,
        mcId:mcId
      },
    ];

    // dispatch(selectName({ name, id }));
    dispatch(selectprocessedData(products));
  };

  const handleSelectChange = (selected) => {
    // console.log("object selected", selected);
    setcategoryHandler({
      id: selected.value,
      name: selected.label,
      mcId: selected.mcId,
    });
    setSelectedOption(selected);
  };

  const customStyles = {
    singleValue: (provided, state) => ({
      ...provided,
      color: state.selectProps.matched ? "red" : "black", // Apply color based on 'matched'
    }),
    // Change the border color of the select box
    control: (provided, state) => ({
      ...provided,
      borderColor: state.selectProps.matched ? "red" : "gray", // Conditional border color
      boxShadow: state.isFocused ? "0 0 0 1px red" : "none",
      // "&:hover": {
      //   borderColor: state.selectProps.matched ? "red" : "gray",
      // },
    }),

    // Change the placeholder text color
    placeholder: (provided, state) => ({
      ...provided,
      color: state.selectProps.matched ? "red" : "gray", // Conditional placeholder color
    }),
  };

  return (
    <div>
      <Select
        styles={{
          ...customStyles,
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
        matched={!matched}
        value={selectedOption}
        options={categoryOptions}
        placeholder={loading ? "Loading categorys..." : "Select category"}
        onChange={handleSelectChange}
        isSearchable
        classNamePrefix="react-select"
        menuPortalTarget={document.body}
      />
    </div>
  );
};

export default SelectCategoryImportSubCategory;
